import React, { useState } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog';
import TextField from '@mui/material/TextField';
import { deleteAction } from 'actions/ocplcAction';
import { useDispatch } from 'react-redux';

const DeleteDialog = ({ isOpen, handleClose, checkedRow, selectedTable, setCheckedRows, setSelectedIds }) => {
    const dispatch = useDispatch();
    const [comments, setComments] = useState('');

    // Check for regionLock
    const isRegionLock = checkedRow[0]?.regionLock;

    const handleDelete = () => {
        const { pkId, whoChanged, productFamily, country, region } = checkedRow[0];
        const input = { pkId, comments, whoChanged, productFamily, handleClose, country, region, selectedTable, setCheckedRows, setSelectedIds };
        dispatch(deleteAction(input));
    };

    return (
        <ConfirmationDialog
        open={isOpen}
        onClose={handleClose}
        title="Delete Confirmation"
        content={
            isRegionLock
                ? "You are not allowed to delete this item."
                : "Are you sure you want to delete this item? Please provide a reason for deletion."
        }
        onConfirm={isRegionLock ? handleClose : handleDelete}
        caption={!isRegionLock && "Delete"}
        bgColor="#BE1313"
        disabled={!isRegionLock && comments.trim() === ''}
    >
        {!isRegionLock && (
            <TextField
                autoFocus
                margin="dense"
                label="Comments"
                type="text"
                fullWidth
                variant="standard"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
            />
        )}
    </ConfirmationDialog>
);
}

export default DeleteDialog;